import { render, staticRenderFns } from "./DetailsDocument.vue?vue&type=template&id=6873b08d"
import script from "./DetailsDocument.vue?vue&type=script&lang=js"
export * from "./DetailsDocument.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports